var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "WordSection1" },
    _vm._l(_vm.items.tabella, function (tab, index) {
      return _c("span", { key: index }, [
        _c(
          "div",
          { class: { hideOnScreen: index > 0 }, attrs: { align: "center" } },
          [
            _c(
              "table",
              {
                staticClass: "MsoNormalTable",
                staticStyle: {
                  width: "468.0pt",
                  "margin-top": "30pt",
                  "border-collapse": "collapse",
                  "mso-yfti-tbllook": "1184",
                  "mso-padding-alt": "0cm 0cm 0cm 0cm",
                },
                attrs: {
                  border: "0",
                  cellspacing: "0",
                  cellpadding: "0",
                  width: "624",
                },
              },
              [
                _c(
                  "tr",
                  { staticStyle: { "mso-yfti-irow": "1", height: "88.05pt" } },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "solid #BFBFBF 1.0pt",
                          "mso-border-alt": "solid #BFBFBF .5pt",
                          padding: "0cm 5.75pt 0cm 5.75pt",
                          height: "88.05pt",
                        },
                        attrs: { colspan: "3", valign: "top" },
                      },
                      [
                        _c("p", { staticClass: "testoallineatoasinistra" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.emittente.Nome) + " "),
                          ]),
                        ]),
                        _c("p", { staticClass: "testoallineatoasinistra" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.emittente.IndirizzoLinea1) + " "),
                          ]),
                        ]),
                        _c("p", { staticClass: "testoallineatoasinistra" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.emittente.IndirizzoLinea2) + " "),
                          ]),
                        ]),
                        _c("p", { staticClass: "testoallineatoasinistra" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.emittente.Telefono) + " "),
                          ]),
                        ]),
                        _c("p", { staticClass: "testoallineatoasinistra" }, [
                          _c("span", [_vm._v(_vm._s(_vm.emittente.Fax) + " ")]),
                        ]),
                        _c("p", { staticClass: "testoallineatoasinistra" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.emittente.Email) + " "),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._m(0, true),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "solid #BFBFBF 1.0pt",
                          "border-left": "none",
                          "border-right": "solid #BFBFBF 1.0pt",
                          padding: "0cm 5.75pt 0cm 5.75pt",
                          height: "88.05pt",
                        },
                        attrs: { colspan: "3", valign: "top" },
                      },
                      [
                        _c("p", { staticClass: "testoallineatoasinistra" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.spedizione.Nome) + " "),
                          ]),
                        ]),
                        _c("p", { staticClass: "testoallineatoasinistra" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.spedizione.IndirizzoLinea1) + " "
                            ),
                          ]),
                        ]),
                        _c("p", { staticClass: "testoallineatoasinistra" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.spedizione.IndirizzoLinea2) + " "
                            ),
                          ]),
                        ]),
                        _c("p", { staticClass: "testoallineatoasinistra" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.spedizione.Telefono) + " "),
                          ]),
                        ]),
                        _c("p", { staticClass: "testoallineatoasinistra" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.spedizione.Fax) + " "),
                          ]),
                        ]),
                        _c("p", { staticClass: "testoallineatoasinistra" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.spedizione.Email) + " "),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._m(1, true),
                _vm._m(2, true),
                _c(
                  "tr",
                  { staticStyle: { "mso-yfti-irow": "3", height: "14.4pt" } },
                  [
                    _vm._m(3, true),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-top": "none",
                          "border-left": "none",
                          "border-bottom": "solid #BFBFBF 1.0pt",
                          "border-right": "solid #BFBFBF 1.0pt",
                          background: "white",
                          padding: "0cm 5.75pt 0cm 5.75pt",
                          height: "14.4pt",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("p", { staticClass: "MsoNormal" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.testata.numeroDDT) + " "),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-top": "none",
                          "border-left": "none",
                          "border-bottom": "solid #BFBFBF 1.0pt",
                          "border-right": "solid #BFBFBF 1.0pt",
                          background: "white",
                          padding: "0cm 5.75pt 0cm 5.75pt",
                          height: "14.4pt",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("p", { staticClass: "MsoNormal" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.testata.dataDDT) + " "),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-top": "none",
                          "border-left": "none",
                          "border-bottom": "solid #BFBFBF 1.0pt",
                          "border-right": "solid #BFBFBF 1.0pt",
                          background: "white",
                          padding: "0cm 5.75pt 0cm 5.75pt",
                          height: "14.4pt",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("p", { staticClass: "MsoNormal" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(index + 1) +
                                " di " +
                                _vm._s(_vm.items.tabella.length)
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._m(4, true),
                _c(
                  "tr",
                  { staticStyle: { "mso-yfti-irow": "5", height: "14.4pt" } },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "solid #BFBFBF 1.0pt",
                          "border-top": "none",
                          background: "white",
                          padding: "0cm 5.75pt 0cm 5.75pt",
                          height: "14.4pt",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("p", { staticClass: "MsoNormal" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.testata.numeroColli) + " "),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-top": "none",
                          "border-left": "none",
                          "border-bottom": "solid #BFBFBF 1.0pt",
                          "border-right": "solid #BFBFBF 1.0pt",
                          background: "white",
                          padding: "0cm 5.75pt 0cm 5.75pt",
                          height: "14.4pt",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("p", { staticClass: "MsoNormal" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.testata.causale) + " "),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-top": "none",
                          "border-left": "none",
                          "border-bottom": "solid #BFBFBF 1.0pt",
                          "border-right": "solid #BFBFBF 1.0pt",
                          background: "white",
                          padding: "0cm 5.75pt 0cm 5.75pt",
                          height: "14.4pt",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("p", { staticClass: "MsoNormal" }, [
                          _c("span", [_vm._v(_vm._s(_vm.testata.porto) + " ")]),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-top": "none",
                          "border-left": "none",
                          "border-bottom": "solid #BFBFBF 1.0pt",
                          "border-right": "solid #BFBFBF 1.0pt",
                          background: "white",
                          padding: "0cm 5.75pt 0cm 5.75pt",
                          height: "14.4pt",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("p", { staticClass: "MsoNormal" }, [
                          _c("span", [
                            _vm._v(" " + _vm._s(_vm.testata.dataOraRitiro)),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _c("p", { class: { hideOnScreen: index > 0 } }, [
          _c("span", [_vm._v("  ")]),
        ]),
        _c("div", { attrs: { align: "center" } }, [
          _c("span", { attrs: { id: "tabella" } }, [
            _c(
              "table",
              {
                class: {
                  MsoNormalTableBreak: index != _vm.items.tabella.length - 1,
                  MsoNormalTable: index == _vm.items.tabella.length - 1,
                },
                staticStyle: {
                  width: "472.95pt",
                  "border-collapse": "collapse",
                  "mso-yfti-tbllook": "1184",
                  "mso-padding-alt": "0cm 0cm 0cm 0cm",
                },
                attrs: {
                  border: "0",
                  cellspacing: "0",
                  cellpadding: "0",
                  width: "631",
                },
              },
              [
                _c(
                  "tr",
                  {
                    class: { hideOnScreen: index > 0 },
                    staticStyle: {
                      "mso-yfti-irow": "0",
                      "mso-yfti-firstrow": "yes",
                      height: "18.0pt",
                    },
                  },
                  [_vm._m(5, true), _vm._m(6, true), _vm._m(7, true)]
                ),
                _vm._l(tab.righe, function (riga, index) {
                  return _c(
                    "tr",
                    {
                      key: `r_${index}`,
                      staticStyle: { "mso-yfti-irow": "1", height: "14.4pt" },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticClass: "cellaItemCapi",
                          attrs: { width: "65" },
                        },
                        [
                          _c("p", { staticClass: "MsoNormal" }, [
                            _c("span", [
                              _vm._v(" " + _vm._s(riga.numeroCapi)),
                              _c("u"),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticClass: "cellaItemDescrizione",
                          attrs: { width: "334" },
                        },
                        [
                          _c("p", [
                            _c("span", [
                              _vm._v(_vm._s(riga.descrizione) + " "),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticClass: "cellaItemNumeroDocumento",
                          attrs: { width: "115" },
                        },
                        [
                          _c("p", { staticClass: "Importo" }, [
                            _c("span", [
                              _vm._v(_vm._s(riga.numeroDocumento) + " "),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
            index < _vm.items.tabella.length - 1
              ? _c("div", { staticStyle: { "page-break-after": "always" } }, [
                  _c("span", {
                    staticClass: "hideOnScreen testoallineatoadestra",
                    staticStyle: { "font-family": '"Arial"' },
                  }),
                ])
              : _vm._e(),
          ]),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "td",
      {
        staticStyle: {
          "border-top": "solid #BFBFBF 1.0pt",
          "border-left": "none",
          "border-bottom": "solid #BFBFBF 1.0pt",
          "border-right": "none",
          "mso-border-left-alt": "solid #BFBFBF .5pt",
          "mso-border-top-alt": "solid #BFBFBF .5pt",
          "mso-border-bottom-alt": "solid #BFBFBF .5pt",
          padding: "0cm 5.75pt 0cm 5.75pt",
          height: "88.05pt",
        },
        attrs: { colspan: "2", valign: "top" },
      },
      [
        _c("p", { staticClass: "intestazionedestra" }, [
          _c("span", [
            _vm._v(" "),
            _c("b", { staticStyle: { "mso-bidi-font-weight": "normal" } }, [
              _vm._v("DESTINATARIO: "),
            ]),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("tr", [_c("td", { attrs: { colspan: "8" } }, [_vm._v(" ")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "tr",
      { staticStyle: { "mso-yfti-irow": "2", height: "18.0pt" } },
      [
        _c(
          "td",
          {
            staticStyle: {
              width: "25%",
              border: "solid #BFBFBF 1.0pt",
              background: "#DBDDCC",
              padding: "0cm 5.75pt 0cm 5.75pt",
              height: "18.0pt",
            },
            attrs: { colspan: "2" },
          },
          [
            _c("p", { staticClass: "intestazionidicolonna" }, [
              _c("strong", [_vm._v("DOCUMENTO")]),
            ]),
          ]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "25%",
              "border-top": "none",
              "border-left": "none",
              "border-bottom": "solid #BFBFBF 1.0pt",
              "border-right": "solid #BFBFBF 1.0pt",
              background: "#DBDDCC",
              padding: "0cm 5.75pt 0cm 5.75pt",
              height: "18.0pt",
            },
            attrs: { colspan: "2" },
          },
          [
            _c("p", { staticClass: "intestazionidicolonna" }, [
              _c("strong", [_vm._v("NUMERO")]),
            ]),
          ]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "25%",
              "border-top": "none",
              "border-left": "none",
              "border-bottom": "solid #BFBFBF 1.0pt",
              "border-right": "solid #BFBFBF 1.0pt",
              background: "#DBDDCC",
              padding: "0cm 5.75pt 0cm 5.75pt",
              height: "18.0pt",
            },
            attrs: { colspan: "2" },
          },
          [
            _c("p", { staticClass: "intestazionidicolonna" }, [
              _c("strong", [_vm._v("DATA")]),
            ]),
          ]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "25%",
              "border-top": "none",
              "border-left": "none",
              "border-bottom": "solid #BFBFBF 1.0pt",
              "border-right": "solid #BFBFBF 1.0pt",
              background: "#DBDDCC",
              padding: "0cm 5.75pt 0cm 5.75pt",
              height: "18.0pt",
            },
            attrs: { colspan: "2" },
          },
          [
            _c("p", { staticClass: "intestazionidicolonna" }, [
              _c("strong", [_vm._v("PAGINA")]),
            ]),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "td",
      {
        staticStyle: {
          border: "solid #BFBFBF 1.0pt",
          "border-top": "none",
          background: "white",
          padding: "0cm 5.75pt 0cm 5.75pt",
          height: "14.4pt",
        },
        attrs: { colspan: "2" },
      },
      [
        _c("p", { staticClass: "MsoNormal" }, [
          _c("strong", [_vm._v("D.D.T.")]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "tr",
      { staticStyle: { "mso-yfti-irow": "4", height: "18.0pt" } },
      [
        _c(
          "td",
          {
            staticStyle: {
              border: "solid #BFBFBF 1.0pt",
              "border-top": "none",
              "mso-border-top-alt": "solid #BFBFBF 1.0pt",
              background: "#DBDDCC",
              padding: "0cm 5.75pt 0cm 5.75pt",
              height: "18.0pt",
            },
            attrs: { colspan: "2" },
          },
          [
            _c("p", { staticClass: "intestazionidicolonna" }, [
              _c("span", [_vm._v("Numero colli ")]),
            ]),
          ]
        ),
        _c(
          "td",
          {
            staticStyle: {
              "border-top": "none",
              "border-left": "none",
              "border-bottom": "solid #BFBFBF 1.0pt",
              "border-right": "solid #BFBFBF 1.0pt",
              "mso-border-top-alt": "solid #BFBFBF 1.0pt",
              background: "#DBDDCC",
              padding: "0cm 5.75pt 0cm 5.75pt",
              height: "18.0pt",
            },
            attrs: { colspan: "2" },
          },
          [
            _c("p", { staticClass: "intestazionidicolonna" }, [
              _c("span", [_vm._v("Causale ")]),
            ]),
          ]
        ),
        _c(
          "td",
          {
            staticStyle: {
              "border-top": "none",
              "border-left": "none",
              "border-bottom": "solid #BFBFBF 1.0pt",
              "border-right": "solid #BFBFBF 1.0pt",
              "mso-border-top-alt": "solid #BFBFBF 1.0pt",
              background: "#DBDDCC",
              padding: "0cm 5.75pt 0cm 5.75pt",
              height: "18.0pt",
            },
            attrs: { colspan: "2" },
          },
          [
            _c("p", { staticClass: "intestazionidicolonna" }, [
              _c("span", [_vm._v("PORTO")]),
            ]),
          ]
        ),
        _c(
          "td",
          {
            staticStyle: {
              "border-top": "none",
              "border-left": "none",
              "border-bottom": "solid #BFBFBF 1.0pt",
              "border-right": "solid #BFBFBF 1.0pt",
              "mso-border-top-alt": "solid #BFBFBF 1.0pt",
              background: "#DBDDCC",
              padding: "0cm 5.75pt 0cm 5.75pt",
              height: "18.0pt",
            },
            attrs: { colspan: "2" },
          },
          [
            _c("p", { staticClass: "intestazionidicolonna" }, [
              _c("span", [_vm._v("Data e ora ritiro ")]),
            ]),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "td",
      {
        staticStyle: {
          width: "48.9pt",
          border: "solid #BFBFBF 1.0pt",
          background: "#DBDDCC",
          padding: "0cm 5.75pt",
          height: "18.0pt",
        },
        attrs: { width: "65" },
      },
      [
        _c("p", { staticClass: "intestazionidicolonna" }, [
          _c("span", [_vm._v("Numero Capi ")]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "td",
      {
        staticStyle: {
          width: "250.6pt",
          border: "solid #BFBFBF 1.0pt",
          "border-left": "none",
          background: "#DBDDCC",
          padding: "0cm 5.75pt",
          height: "18.0pt",
        },
        attrs: { width: "334" },
      },
      [
        _c("p", { staticClass: "intestazionidicolonna" }, [
          _c("span", [_vm._v("Descrizione ")]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "td",
      {
        staticStyle: {
          width: "86.55pt",
          "border-top": "solid #BFBFBF 1.0pt",
          "border-left": "none",
          "border-bottom": "solid #BFBFBF 1.0pt",
          "border-right": "solid #BFBFBF  1.0pt",
          "mso-border-top-alt": "solid #BFBFBF 1.0pt",
          "mso-border-bottom-alt": "solid #BFBFBF 1.0pt",
          "mso-border-right-alt": "solid #BFBFBF .5pt",
          background: "#DBDDCC",
          padding: "0cm 5.75pt",
          height: "18.0pt",
        },
        attrs: { width: "115" },
      },
      [
        _c("p", { staticClass: "intestazionidicolonna" }, [
          _c("span", [_vm._v("Numero Documento ")]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }